import { useState, useEffect, useMemo } from 'react';

// Process-lifetime fetch cache: cacheKey -> { data: [], loading: bool, error: any }
// Cache key is `${principalURN}:${threadURN}` to scope per thread.
const commitmentCache = new Map();

export function useCommitments({ principalURN, threadURN }) {
  const cacheKey = principalURN ? `${principalURN}:${threadURN || ''}` : null;
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!principalURN) return;
    if (commitmentCache.has(cacheKey)) return;
    commitmentCache.set(cacheKey, { data: [], loading: true, error: null });

    const params = new URLSearchParams({
      entity_type: 'memory',
      kind: 'commitment',
      limit: '50',
    });
    if (principalURN) params.set('subject', principalURN);
    if (threadURN) params.set('fromThread', threadURN);

    window.fetch(`/api/memory?${params}`)
      .then(r => r.json())
      .then(d => {
        commitmentCache.set(cacheKey, { data: d.memories || d.items || [], loading: false, error: null });
        setTick(t => t + 1);
      })
      .catch(err => {
        commitmentCache.set(cacheKey, { data: [], loading: false, error: err });
        setTick(t => t + 1);
      });
  }, [cacheKey]);

  const filtered = useMemo(() => {
    const entry = cacheKey ? commitmentCache.get(cacheKey) : null;
    return entry?.data || [];
  }, [cacheKey, tick]);

  const loading = cacheKey
    ? (commitmentCache.get(cacheKey)?.loading ?? !commitmentCache.has(cacheKey))
    : false;

  return { commitments: filtered, loading, approximate: false };
}
